import axios from "axios";
import { axiosWithKey } from "~/axios";
import { getToken } from "~/redux/user/tokens";

const SEARCH_FILTER_ITEMS = "searchFilterItems";
const CHOSEN_FILTER_ITEMS = "chosenFilterItems";

export const toggler = (iArr, iStr) =>
  iArr.includes(iStr) ? iArr.filter(el => el !== iStr) : [...iArr, iStr];

export const getTags = (arr, str) =>
  arr.filter(t => t.tagType === str).map(t => ({ title: t.title }));

export const getFilterItemsFromClientStorage = () =>
  JSON.parse(window.localStorage.getItem(SEARCH_FILTER_ITEMS)) || {};

export const getChosenItemsFromClientStorage = () => 
  JSON.parse(window.localStorage.getItem(CHOSEN_FILTER_ITEMS))

export const saveFilterItemsToClientStorage = items => {
  const currentItems = getFilterItemsFromClientStorage(),
    updatedItems = JSON.stringify({
      ...currentItems,
      ...items,
      expirationDate: Date.now() + 24 * 60 * 60 * 1000
    });
  window.localStorage.setItem(SEARCH_FILTER_ITEMS, updatedItems);
};

export const saveChosenItemsToClientStorage = newStateObj => {
  const currentChosenItems = getChosenItemsFromClientStorage() || {};
  const updatedChosenItems = JSON.stringify({
    ...currentChosenItems,
    ...newStateObj
  })
  window.localStorage.setItem(CHOSEN_FILTER_ITEMS, updatedChosenItems);
}

export const getCachedTags = () => {
  const filterItems = getFilterItemsFromClientStorage();
  const {
    equipment,
    times,
    concepts,
    brands,
    instructors,
    music,
    expirationDate
  } = filterItems;
  if (
    equipment &&
    times &&
    concepts &&
    brands &&
    instructors &&
    music &&
    Date.now() < expirationDate
  ) {
    return {
      equipment,
      times,
      concepts,
      brands,
      instructors,
      music
    };
  } else {
    return null;
  }
};

export const createSearchQueryURL = state => {
  const { apiBaseUrl, internalName } = window.settings;
  const {
    chosenEquipment,
    chosenTimes,
    chosenConcepts,
    chosenBrands,
    chosenInstructors,
    chosenMusic,
    explicit,
    inputText
  } = state;

  const url = `${apiBaseUrl}/search/v1?site=${internalName}&types=video`;
  const params = {
    searchTerm: inputText.replace(/ /g, "+"),
    instructors: chosenInstructors.map(i => i.replace(/ /g, "+")).join(","),
    concepts: chosenConcepts.join(","),
    music: chosenMusic.map(b => b.replace(/ /g, "+")).join(","),
    equipment: chosenEquipment.map(b => b.replace(/ /g, "+")).join(","),
    time: chosenTimes.map(b => b.replace(/ /g, "+")).join(","),
    brands: chosenBrands.map(b => b.replace(/ /g, "+")).join(",")
  };
  const explicitParam = `&explicit=${Boolean(explicit.length)}`;
  const queryString = Object.keys(params)
    .filter(k => !!params[k])
    .map(key => key + "=" + params[key])
    .join("&");

  return queryString
    ? `${url}&${queryString}${explicitParam}`
    : `${url}${explicitParam}`
}

export const fetchTags = () =>
  new Promise((resolve, reject) => {
    const { internalName } = window.settings;
    getToken(token => {
      return axiosWithKey({
        method: "GET",
        url: `fitness/all-equipment?site=${internalName}`,
        headers: { Authorization: token }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  });

export const fetchConcepts = () =>
  new Promise((resolve, reject) => {
    const { internalName } = window.settings;
    getToken(token => {
      return axiosWithKey({
        method: "GET",
        url: `content/categories?site=${internalName}&languageCode=default`,
        headers: { Authorization: token }
      })
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  });

export const fetchInstructors = () =>
  new Promise((resolve, reject) => {
    const { internalName } = window.settings;
    axios
      .get(
        window.settings.apiBaseUrl +
          `/search/v2/list?site=${internalName}&type=person`
      )
      .then(d => d.data)
      .then(resolve)
      .catch(reject);
  });
